<template>
  <v-dialog width="350px" fullscreen v-model="editDialog">
    <v-btn flat fab color="lime" slot="activator">
      <v-icon>create</v-icon>
    </v-btn>
    <v-card>
      <v-toolbar dark color="primary">
        <v-btn icon dark @click="editDialog = false">
          <v-icon>close</v-icon>
        </v-btn>
        <v-toolbar-title>Edit - {{contact.name}}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn dark flat @click="onSaveChanges">Update</v-btn>
        </v-toolbar-items>
      </v-toolbar>

      <v-layout row wrap>
        <v-flex xs12 md4>
          <v-text-field v-model="editedName" :counter="30" label="Name" ></v-text-field>
        </v-flex>

        <v-flex xs12 md4>
          <v-text-field v-model="editedEmail" :counter="30" label="E-mail"></v-text-field>
        </v-flex>
        <v-flex xs12 md4>
          <v-text-field v-model="editedworkNo" :counter="3" label="Work Number"></v-text-field>
        </v-flex>
        <v-flex xs12 md4>
          <v-text-field v-model="editedPosition" label="Position" ></v-text-field>
        </v-flex>
        <v-flex xs12 md4>
          <v-text-field v-model="editedArea" label="Area" ></v-text-field>
        </v-flex>
        <v-flex xs12 md4>
          <v-text-field v-model="editedSector" label="Sector"></v-text-field>
        </v-flex>
        <v-flex xs12 md6>
          <v-text-field v-model="editedMobile" :counter="15" label="Mobile (full)"></v-text-field>
        </v-flex>
        <v-flex xs12 md6>
          <v-text-field v-model="editedMobile_short" :counter="5" label="Mobile (Short)"></v-text-field>
        </v-flex>
        <v-flex xs12 md3>
          <v-text-field v-model="editedPin1" :counter="4" label="Pin 1"></v-text-field>
        </v-flex>
        <v-flex xs12 md3>
          <v-text-field v-model="editedPuk1" :counter="8" label="Puk 1"></v-text-field>
        </v-flex>
        <v-flex xs12 md3>
          <v-text-field v-model="editedPin2" :counter="4" label="Pin 2"></v-text-field>
        </v-flex>
        <v-flex xs12 md3>
          <v-text-field v-model="editedPuk2" :counter="8" label="Puk 2"></v-text-field>
        </v-flex>
        <v-flex xs12 md3>
          <v-text-field v-model="editedSim" :counter="20" label="Sim Card"></v-text-field>
        </v-flex>
      </v-layout>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: ["contact"],
  data() {
    return {
      editDialog: false,
      editedName: this.contact.name,
      editedEmail: this.contact.email,
      editedworkNo: this.contact.work_No,
      editedPosition: this.contact.position,
      editedArea: this.contact.area,
      editedSector: this.contact.sector,
      editedMobile: this.contact.mobile,
      editedMobile_short: this.contact.mobile_short,
      editedPin1: this.contact.pin1,
      editedPuk1: this.contact.puk1,
      editedPin2: this.contact.pin2,
      editedPuk2: this.contact.puk2,
      editedSim: this.contact.sim
    };
  },
  methods: {
    onSaveChanges() {
      this.editDialog = false;

      this.$store.dispatch("editContact", {
        id: this.contact.id,
        name: this.editedName,
        work_No: this.editedworkNo,
        position: this.editedPosition,
        area: this.editedArea,
        sector: this.editedSector,
        mobile: this.editedMobile,
        mobile_short: this.editedMobile_short,
        pin1: this.editedPin1,
        pin2: this.editedPin2,
        puk1: this.editedPuk1,
        puk2: this.editedPuk2,
        sim: this.editedSim
      });
    }
  }
};
</script>